import http from "./http";

// 上传讲义资料
export function upload_resources_api() {
  return "/api/course/chapter/handout/material";
}

// 上传课程图片
export function upload_resources_image_api() {
  return "/api/file";
}

// 获取地址
export function post_image_url_api(data = {}) {
  return new Promise((resolve, reject) => {
    http.post("file/urls", data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
